<script lang="ts">
	import type { LandingItemContext, RestaurantsDynamic, RestaurantsSemiStatic } from "$lib/def/landing";
	import type { Cache } from "$lib/serv/core/cache";
	import { KEY_DEALS, type DealsLoader } from "$lib/serv/food-landing";
	import LoadingIcons from "$lib/ui/shared/LoadingIcons.svelte";
	import { query, queryFrom } from "$lib/util/url";
	import { getContext } from "svelte";
	import Tiles from "./Tiles.svelte";

	export let deals: DealsLoader | null;
	export let semistatic: Cache<RestaurantsSemiStatic> | null;
	export let dynamic: Cache<RestaurantsDynamic> | null;
	export let searchParams: Record<string, string>;
	const { base, cacheAge } = getContext('endpoints') as LandingItemContext;
	
</script>

{#if deals}
	{#if deals.loading}
		<LoadingIcons />
	{:else if deals.error}
		<p>{deals.error}</p>
	{:else if deals.payload}
		{@const tabs = deals.selectors}
		{#if tabs}
			<div class="pills label-xl book">
				{#each tabs as tab}
					{#if tab.deals.length}
						{#if tab.filtering_type === 'ALL'}
							<a href="?{queryFrom(searchParams).set(KEY_DEALS, null)}"
								class="label-xl book"
								class:active={ !queryFrom(searchParams).has(KEY_DEALS)}>
								{tab.label}
							</a>
						{:else}
							<a href="?{queryFrom(searchParams).toggle(KEY_DEALS, tab.filtering_type)}"
								class="label-xl book"
								class:active={queryFrom(searchParams).hasValue(KEY_DEALS, tab.filtering_type)}>
								{tab.label}
							</a>
						{/if}
					{/if}
				{/each}
			</div>
		{/if}
		<Tiles
			{searchParams}
			group={null}
			{semistatic}
			{dynamic}
			{deals}
			filteredList={deals.selectors?.find(s => s.filtering_type === (searchParams[KEY_DEALS] || s.filtering_type))?.ids ?? []}
		/>
	{/if}
{/if}

